/** Expand compact ongoing-trials API payload (trials_by_id + trial_refs) into grouped trials. */
export function expandOngoingTrialsResponse(response: {
  data?: Array<{
    indication_code: string;
    indication_name: string;
    trials?: Record<string, unknown>[];
    trial_refs?: Array<{ id: number }>;
  }>;
  trials_by_id?: Record<string, Record<string, unknown>>;
}) {
  const trialsById = response.trials_by_id;
  if (!trialsById) {
    return response.data || [];
  }
  return (response.data || []).map((group) => ({
    indication_code: group.indication_code,
    indication_name: group.indication_name,
    trials: (group.trial_refs || []).map((ref) => {
      const base = trialsById[String(ref.id)] || { id: ref.id };
      return {
        ...base,
        indication_code: group.indication_code,
        indication_name: group.indication_name,
        indication_details: group.indication_name,
      };
    }),
  }));
}
